import { render, staticRenderFns } from "./Applications.vue?vue&type=template&id=3b61f049&"
import script from "./Applications.vue?vue&type=script&lang=js&"
export * from "./Applications.vue?vue&type=script&lang=js&"
import style0 from "./Applications.vue?vue&type=style&index=0&id=3b61f049&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports